import { type FC } from 'react';

import { useTimerToEnd } from '@/common/hooks/timer-to-end';
import { timeStringFormatShortForm } from '@/common/lib/timer';
import { MiniTimer } from '@/components/ui/MiniTimer/MiniTimer';
import { changeDailyGoodsLinkStatus } from '@/redux/reducers/appReducer';
import { useAppDispatch } from '@/redux/store';

interface DailyGoodsTimerCycleProps {
  expiredAt?: string;
}

const DailyGoodsTimerCycle: FC<DailyGoodsTimerCycleProps> = ({ expiredAt }) => {
  const dispatch = useAppDispatch();
  const time = useTimerToEnd(expiredAt, (): void => {
    dispatch(changeDailyGoodsLinkStatus(false));
    localStorage.removeItem('daily-goods-upgrade-modal-visit');
  });

  return (
    <MiniTimer
      className="px-2"
      time={timeStringFormatShortForm((time || 0) * 1000, true)}
    />
  );
};

export { DailyGoodsTimerCycle };
